// extracted by mini-css-extract-plugin
module.exports = {"finishedQuiz":"FinishedQuiz_finishedQuiz__IeNoE","success":"FinishedQuiz_success__zLki_","error":"FinishedQuiz_error__2yjI5"};